import React from "react";
import { Appheader } from "../header/header-component";
import { GenericDialogBox } from "../dialog/dialog-component";
import { AppFolderSelectComponent } from "../components/folder-select/folder-select-component";
import style from "./create-session.module.css";
import style2 from "../dialog/dialog.module.css";
import openFolderIcon from "../assets/img/open-folder.svg";
import podIcon from "../assets/img/icon-pod.svg";
import LightIcon from "@icons/Light";
import { adjDim } from "../myhooks/custom-hooks";

function CreateSessionPage(props) {
  return (
    <>
      <div className="main-container items-center">
        <Appheader
          title={props.pageTitle}
          leftText={false}
          rightText={""}
          rightEnabled={false}
          nav={() =>
            props.openDialog(
              "Back",
              "Are you sure you want to go back to the session list?"
            )
          }
        />
        {props.currentMenu === "Settings" ? (
          <React.Fragment>
            <div className="center-column-container text-center">
              <div>Discussion name:</div>
              <input
                id="txtName"
                className="text-box"
                defaultValue={props.sessionName}
                onKeyUp={(event) => props.setSessionName(event.target.value)}
                maxLength="64"
              />
              <div>Folder: </div>
              <div
                className="flex flex-row w-full items-center"
              >
                <input
                  type="text"
                  className="text-box flex-grow"
                  name="Location"
                  placeholder={props.folderPath}
                  readOnly
                />
                <img
                  src={openFolderIcon}
                  className="w-9 h-auto"
                  onClick={() => props.openDialog("Folder", "test")}
                />
              </div>
              <label className={style["dc-checkbox"]}>
                Allow participant devices
                <input
                  type="checkbox"
                  checked={props.byod}
                  value={props.byod}
                  onChange={() => props.setByod(!props.byod)}
                />
                <span className={style.checkmark}></span>
              </label>
              <label className={style["dc-checkbox"]}>
                Analyze discussion features
                <input
                  type="checkbox"
                  checked={props.features}
                  value={props.features}
                  onChange={() => props.setFeatures(!props.features)}
                />
                <span className={style.checkmark}></span>
              </label>
            </div>
            <div className={style["button-side-container"]}>
              <button
                className={style["footer-button"]}
                style={{ width: adjDim(374 / 2) + "px", "margin-right": "5px" }}
                onClick={props.navigateToSessions}
              >
                Back
              </button>
              <button
                className={style["footer-button"]}
                style={{ width: adjDim(374 / 2) + "px", "margin-left": "5px" }}
                onClick={props.goToDevices}
              >
                Next
              </button>
            </div>
          </React.Fragment>
        ) : (
          <></>
        )}
        {props.currentMenu === "Devices" ? (
          <React.Fragment>
            <div className={style["list-container"]}>
              {props.devices.length === 0 ? (
                <div className={style["empty-keyword-list"]}>
                  <div className={style["load-text"]}> No Devices </div>
                </div>
              ) : (
                <></>
              )}
              {props.devices.length > 0 ? (
                <ul className={style.list}>
                  {props.devices.map((device) => {
                    <li
                      className={
                        props.selectedDevices.includes(device)
                          ? style["selected-pod"]
                          : style["pod-item"]
                      }
                      onClick={() => props.deviceSelected(device)}
                    >
                      <img className={style["pod-icon"]} src={podIcon} />
                      <div className={style["pod-text"]}>{device.name}</div>
                      <div className={style["button-container"]}>
                        <button
                          className={
                            device.blinking
                              ? style["selected-button"]
                              : style["pod-button"]
                          }
                          onClick={(event) => props.blinkPod(event, device)}
                        >
                          <svg
                            x="0"
                            y="0"
                            width="20"
                            height="20"
                            viewBox="0 0 512 512"
                            className={style["light-svg"]}
                          >
                            <LightIcon></LightIcon>
                          </svg>
                        </button>
                      </div>
                    </li>;
                  })}
                </ul>
              ) : (
                <></>
              )}
            </div>
            <button
              className={style["select-all"]}
              onClick={props.onClickSelectAll}
            >
              Select All
            </button>
            <button
              className={style["footer-button"]}
              style={{ width: adjDim(374) + "px" }}
              onClick={props.goToSettings}
            >
              Back
            </button>
            <button
              className={style["footer-button"]}
              style={{ width: adjDim(374) + "px" }}
              onClick={props.createSession}
            >
              Start Discussion
            </button>
          </React.Fragment>
        ) : (
          <></>
        )}
      </div>

      <GenericDialogBox show={props.currentForm !== ""}>
        {props.currentForm === "Error" ? (
          <div className={style["add-dialog"]}>
            <div className={style2["dialog-heading"]}>Invalid Session</div>
            {props.displayText}
            <button
              className={style["cancel-button"]}
              onClick={props.closeDialog}
            >
              Close
            </button>
          </div>
        ) : (
          <></>
        )}

        {props.currentForm === "Back" ? (
          <div className={style["add-dialog"]}>
            {props.displayText}
            <button
              className={style["dialog-button"]}
              onClick={() => props.navigateToSessions()}
            >
              Go Back
            </button>
            <button
              className={style["cancel-button"]}
              onClick={props.closeDialog}
            >
              Cancel
            </button>
          </div>
        ) : (
          <></>
        )}

        {props.currentForm === "Folder" ? (
          <div className={style["dialog-window"]}>
            <div className={style2["dialog-heading"]}>Select Folder</div>
            <AppFolderSelectComponent
              selectableFolders={props.folders}
              setFolderSelect={props.setFolderSelect}
              setBreadCrumbSelect={props.setBreadCrumbSelect}
            />
            {/* <app-folder-select #folderSelect [folders]="folders" (itemSelected)="receiveEmmitedFolder($event)"></app-folder-select> */}
            {props.folderSelect ? (
              <button
                className={style["dialog-button"]}
                onClick={() =>
                  props.setFolderLocation(
                    props.folderSelect,
                    props.breadCrumbSelect
                  )
                }
              >
                OK
              </button>
            ) : (
              <></>
            )}
            <button
              className={style["cancel-button"]}
              onClick={props.closeDialog}
            >
              Cancel
            </button>
          </div>
        ) : (
          <></>
        )}
      </GenericDialogBox>
    </>
  );
}

export { CreateSessionPage };
